// import AddAmbulance from "./addAmbulance";
import AllAmbulances from "./allAmbulances";

function AmbulanceManagement() {
  return (<>
    {/* <AddAmbulance /> */}
    <AllAmbulances />
  </>);
}

export default AmbulanceManagement